import React from "react";
import styles from "./reports.module.scss";
import { cn } from "utils";
import { useLocation, useNavigate } from "react-router-dom";
import routes from "constants/routes";
import { reportsMerger } from "utils/reports";

const tabs = [
  {
    label: "All Reports",
    url: reportsMerger(routes.REPORTS.ALL_REPORTS),
    active: true,
  },
  {
    label: "Authorization Docs",
    url: reportsMerger(routes.REPORTS.AUTHORIZATION_DOCS),
  },
  {
    label: "Company Tax Docs",
    url: reportsMerger(routes.REPORTS.COMPANY_TAX_DOCS),
  },
  {
    label: "Employee Tax Docs",
    url: reportsMerger(routes.REPORTS.EMPLOYEE_TAX_DOCS),
  },
  {
    label: "Contractor Tax Docs",
    url: reportsMerger(routes.REPORTS.CONTRACTOR_TAX_DOCS),
  },
];

const TabList = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (
    <div className={styles.tabListContainer}>
      {tabs.map(({ label, url, active }) => {
        return (
          <button
            key={url}
            className={cn(pathname === url ? styles["active"] : "")}
            onClick={() => navigate(url)}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
};

export default TabList;
